export default {
  title: 'Trial has expired',
  body: 'If you want to continue using paid features, click the "Get a tariff" button.',
  ok: 'Get a tariff',
  cancel: 'Cancel'
}
